import React from "react";
import ReactHtmlParser from "react-html-parser";
import {ProductMemberPricing} from "../components/ProductMemberPricing";
import { ProductCardActionButton } from "./ProductCardActionButton";

export class ProductCardBlockStyle extends React.Component<any, any> {
	constructor(props:any) {
		super(props);
	}

	render(): React.ReactNode {
		var product = this.props.data;
		return (
			<>
				{ !( product.stock_status === 'outofstock' && product.hide_out_of_stock === 'yes') ?
					<>
					{ !( product.stock_status === 'outofstock' && product.manage_stock === 'no') ?
						<>
							<div className="product--list-item">
								<div className="product_wrapper">
									<div className="product_block_style">
										<div className="product_image_wrapper">
											<div className="product_image_content">
												{ product.product_image.length > 0 ?
													<div className='product--image-wrapper'>{ReactHtmlParser(product.product_image)}</div>
													: null 
												}
											</div>
											<div className="product_image_overlay">
												<div className="product_overaly">
													<a href={product.product_permalink} className="product_read_more">Read More</a>
												</div>
											</div>
											{product.is_on_sale && product.enable_sale_icon ?
												<>
													{ product.stock_status === 'instock' ?
														<>
															<div className="product_on_sale">Sale!</div>
														</>
														: <div className="product_out_stock">Out!</div>
													}
												</>
												: null
											}
										</div>
										<div className="product_content_wrapper">
											{/* <div className="product_author"></div> */}
											<div className="product_title">
												{ product.product_permalink.length > 0 ? 
													<a href={ product.product_permalink }>{ product.product_name }</a>
													: <a href='#'>{ product.product_name }</a>
												}
											</div>
											<div className="product_footer price">
												{/* <div className="product_meta">
												</div> */}
												<div className="product_price">
													<ProductMemberPricing
														productOnSale={product.is_on_sale}
														productInCart={product.in_cart}
														productPurchased={product.purchased}
														productMemPrice={product.product_mem_pricing}
														productPrice={product.product_price}
														productPriceText={product.product_price_txt}
														productRegularPrice={product.product_regular_price}
														product={product}
													/>
												</div>
												<ProductCardActionButton key={`product-action-button-${product.id}`} product={product} />
											</div>
										</div>
									</div>
								</div>
							</div>
						</>
						: null
					}
					</>
					: null
				}
			</>
		);
	}
}